import { render } from 'react-dom';

const ReactComponentRenderer = createComponent => {
  const renderComponent = async () => {
    const container = document.getElementById('react-container');
    const myProps = {
      props: JSON.parse(container.dataset.props),
    };
    const MainAppComponent = await createComponent(myProps);
    render(MainAppComponent, container);
  };

  const checkDocumemtState = () => {
    if (document.readyState === 'complete') {
      renderComponent();
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        renderComponent();
      });
    }
  };

  return checkDocumemtState();
};

export default ReactComponentRenderer;
